import React, { useState, useEffect } from 'react'
import HeaderTwoTop from './HeaderTwoTop'
import mainLogo from '../../assets/img/logo-color.png';
import { Link } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import MobileMenuTwo from './MobileMenuTwo';

const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
        const headerOffset = document.querySelector('.header-wrap')?.offsetHeight || 80;
        const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
    }
};

const HeaderTwo = () => {
    const [search, setSearch] = useState(true);
    const [mobileMenu, setMobileMenu] = useState(true);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const currentScrollY = window.scrollY;

                    // Always show navbar at the very top
                    if (currentScrollY < 10) {
                        setIsVisible(true);
                    }
                    // Hide when scrolling down (after 100px), show when scrolling up
                    else if (currentScrollY > lastScrollY && currentScrollY > 100) {
                        setIsVisible(false);
                    } else if (currentScrollY < lastScrollY) {
                        setIsVisible(true);
                    }

                    setLastScrollY(currentScrollY);
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    const handleSearch = () => {
        setSearch(!search);
    }

    const handleMobileMenu = () => {
        setMobileMenu(!mobileMenu);
    }

    return (
        <header className={`header-wrap header-2 ${isVisible ? 'header-visible' : 'header-hidden'}`}>
            <HeaderTwoTop />
            <div className="main-header-wrapper">
                <div className="container-fluid align-items-center justify-content-between d-flex">
                    <div className="logo">
                        <Link to="/"><img
                            className="logo-icon"
                            src="/img/dhtech-icon.svg"
                            alt="logo"
                        /></Link>
                    </div>
                    <div className="main-menu d-none d-lg-block">
                        <ul>
                            <li><a href="/" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
                            <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Quick Services</a></li>
                            <li><a href="#detailed-services" onClick={(e) => { e.preventDefault(); scrollToSection('detailed-services'); }}>Detailed Services</a></li>
                            <li><a href="#why-choose-us" onClick={(e) => { e.preventDefault(); scrollToSection('why-choose-us'); }}>Why Choose Us</a></li>
                        </ul>
                    </div>
                    <div className="d-inline-block d-lg-none">
                        <div className="mobile-nav-wrap">
                            <div id="hamburger" onClick={handleMobileMenu}>
                                <i className="fal fa-bars"></i>
                            </div>
                            <MobileMenuTwo mobileMenu={mobileMenu} handleMobileMenu={handleMobileMenu} />
                        </div>
                        <div className="overlay"></div>
                    </div>
                    <a
                        className="call-action theme-btn"
                        href="https://wa.me/971502033924"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Request Services
                    </a>
                </div>
            </div>
        </header>
    )
}

export default HeaderTwo